__turbopack_context__.v({
  "variantBar": "DemoVariantBar-module__GS7UEW__variantBar",
  "variantSelect": "DemoVariantBar-module__GS7UEW__variantSelect",
});
